(function () {
  "use strict";
  window.__evamatsCanonicalPropertiesLoaded = true;
  document.documentElement.dataset.evmCanonicalScript = "loaded";

  function sync(root, type) {
    var checked = root.querySelector('fieldset[data-type="' + type + '"] input[type="radio"]:checked');
    if (!checked) return;

    var linkedInput = checked.hasAttribute("form") ? checked : root.querySelector("input[form]");
    var form = linkedInput && document.getElementById(linkedInput.getAttribute("form"));
    var metadataScope = form || root;
    metadataScope.dataset.evmCanonicalSync = type;
    var canonical = metadataScope.querySelector('[data-evm-canonical="' + type + '"]');
    var label = metadataScope.querySelector('[data-evm-label="' + type + '"]');
    var property = metadataScope.querySelector('[data-evm-property="' + type + '"]');

    if (canonical) canonical.value = checked.dataset.value || "";
    if (label) label.value = checked.value || "";
    if (property) {
      var match = String(checked.name || "").match(/^properties\[(.*)]$/);
      if (match) property.value = match[1];
    }
  }

  function syncAll(root) {
    ["matPattern", "matColor", "trimColor", "bodyType"].forEach(function (type) {
      sync(root, type);
    });
  }

  function syncAllRoots() {
    var roots = document.querySelectorAll(".config_container");
    if (!roots.length) roots = document.querySelectorAll(".product__config_main");
    roots.forEach(function (root) {
      syncAll(root);
    });
  }

  function boot() {
    window.__evamatsCanonicalPropertiesBooted = (window.__evamatsCanonicalPropertiesBooted || 0) + 1;
    document.documentElement.dataset.evmCanonicalBoot = "ready";
    syncAllRoots();
    window.requestAnimationFrame(syncAllRoots);
    window.setTimeout(syncAllRoots, 300);
    window.setTimeout(syncAllRoots, 1200);
  }

  document.addEventListener("change", function (event) {
    var fieldset = event.target && event.target.closest && event.target.closest("fieldset[data-type]");
    var root = fieldset && (fieldset.closest(".config_container") || fieldset.closest(".product__config_main"));
    if (root) sync(root, fieldset.dataset.type);
  }, true);

  document.addEventListener("submit", syncAllRoots, true);
  document.addEventListener("click", function (event) {
    if (event.target && event.target.closest && event.target.closest(".product__dropdown_button, [name='add']")) {
      window.setTimeout(syncAllRoots, 0);
    }
  }, true);
  window.addEventListener("pageshow", syncAllRoots);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
